export default __webpack_public_path__ + "/dist/images/termcondition-active.c356c656d82dac058cde9bc316cbe516.svg";